
import ProductSliderListItem from '@/components/ProductSliderListItem.vue'

export default {
  components: {
    ProductSliderListItem,
  },

  props: {
    products: Array,
    itemsPerSlide: {
      type: Number,
      default: 5,
    },
    isInCart: {
      type: Boolean,
      default: false,
    },
    isFromSlider: {
      type: Boolean,
      default: false,
    },
    productMaxWidth: {
      type: Number,
      default: 320,
    },
  },
}
